export default "__VITE_ASSET__f996f38a__"